import {Component} from '@angular/core';
import {StoreSelectorsService} from "../../../../services";
import {MatDialog} from "@angular/material/dialog";
import {IBaseBlockComponent, IEventBlock, IPlayerProps, IPlayerPropsEvents} from "../../../../interfaces";
import {TranslocoService} from "@ngneat/transloco";
import {BlockBaseComponent} from "../block-base/block-base.component";
import {actionUpdateEventsStrings} from "../../../../store/actions/user.actions";
import {MimeAnomalyType} from '../block-constants';
import {take} from "rxjs/operators";
import {isNullOrUndef, isStringBasedJson} from "../../../../common";
import {DialogEventsExplorerComponent} from "../../../events/dialog-events-explorer/dialog-events-explorer.component";
import {DialogJsonEditorComponent, DialogJsonEditorData, EditorMode} from "../../../../components/dialog-json-editor/dialog-json-editor.component";


@Component({
    selector: 'app-block-send-events',
    templateUrl: './block-send-events.component.html',
    styleUrls: ['./block-send-events.component.scss'],
    standalone: false
})
export class BlockSendEventsComponent extends BlockBaseComponent implements IBaseBlockComponent {
    readOnly = false;

    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override preInit() {
        super.preInit();
    }

    dispatchChanges(values) {
        this.dispatchSceneItemChanges({
            sceneId: this.sceneId,
            sceneItemId: this.sceneItem.$.id,
            values: [{
                key: 'EventCommands',
                value: [{
                    EventCommand: values
                }],
                storePath: `Data[0]`
            }]
        });
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                restrictChar: 'basic3',
                value: '',
                label: this.translocoService.translate('general.eventItemName3', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                textSideButton: {
                    icon: 'notification_add',
                    callBackSideButton: (e, value) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        this.openEventsExplorerDialog(e, value);
                    }
                },
                // observable: this.storeSelector.getEmpty(),
                callBackValue: (item, direction) => this.dispatchEventsAll(),
                name: "clickEventName",
                storePath: '$.clickEventName'
            },
            {
                type: "input",
                restrictChar: 'basic3',
                value: '',
                label: this.translocoService.translate('general.eventItemParam3', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                readonly: true,
                textSideButton: {
                    icon: 'edit',
                    callBackSideButton: (e, value) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        this.openJsonTextEditorDialog('clickEventParam');
                    }
                },
                name: "clickEventParam",
                storePath: '$.clickEventParam'
            },
            {
                type: "input",
                restrictChar: 'basic3',
                value: '',
                label: this.translocoService.translate('general.eventName3', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                // observable: this.storeSelector.getEmpty(),
                callBackValue: (item, direction) => this.dispatchEventsAll(),
                name: "selectItemEventName",
                storePath: '$.selectItemEventName'
            },
            {
                type: "input",
                restrictChar: 'basic3',
                value: '',
                label: this.translocoService.translate('general.eventParam3', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                readonly: true,
                textSideButton: {
                    icon: 'edit',
                    callBackSideButton: (e, value) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        this.openJsonTextEditorDialog('selectItemEventParam');
                    }
                },
                name: "selectItemEventParam",
                storePath: '$.selectItemEventParam'
            },
            {
                type: "input",
                restrictChar: 'basic3',
                value: '',
                label: this.translocoService.translate('general.changeEventName', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                textSideButton: {
                    icon: 'notification_add',
                    callBackSideButton: (e, value) => {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        this.openEventsExplorerDialog(e, value);
                    }
                },
                callBackValue: (item, direction) => this.dispatchEventsAll(),
                name: "changeEventName",
                storePath: '$.changeEventName'
            }
        ];
    }

    dispatchEventsAll() {
        const eventsAll = [];
        if (this.sceneItem?.$?.selectItemEventName)
            eventsAll.push(this.sceneItem.$.selectItemEventName);
        if (this.sceneItem?.$?.clickEventName)
            eventsAll.push(this.sceneItem.$.clickEventName);
        if (this.sceneItem?.$?.changeEventName)
            eventsAll.push(this.sceneItem.$.changeEventName);
        this.storeSelector.dispatch(actionUpdateEventsStrings({eventsStrings: eventsAll}));
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        const playerId = this.storeSelector.isBlockIdJsonAliased(this.sceneItem);

        // Handle changeEventName visibility for Knob and ColorControl components
        if (playerId === this.blockLabelRecords.KNOB.id || playerId === this.blockLabelRecords.COLOR_CONTROL.id || playerId === this.blockLabelRecords.SWITCH.id || playerId === this.blockLabelRecords.ALARM_SYS.id) {
            // These components only use changeEventName (dynamic value from interaction)
            this.setUiConfigHide('clickEventName', true);
            this.setUiConfigHide('clickEventParam', true);
            this.setUiConfigHide('selectItemEventName', true);
            this.setUiConfigHide('selectItemEventParam', true);
            this.setUiConfigHide('changeEventName', false);
        } else if (playerId === this.blockLabelRecords.JSON_PLAYER.id) {
            // JsonPlayer: select event Name + Param (legacy parity). Both may be a literal value or a
            // $selectedItem.<field> token that the player resolves per-row from the selected record
            // (legacy uses $selectedItem.selectEvent for the name, $selectedItem.selectParam for the
            // param). An empty Param falls back to dispatching the whole selected record as the payload.
            this.setUiConfigHide('changeEventName', true);
            this.setUiConfigHide('clickEventName', true);
            this.setUiConfigHide('clickEventParam', true);
            this.setUiConfigHide('selectItemEventName', false);
            this.setUiConfigHide('selectItemEventParam', false);
        } else {
            // Default behavior for other components
            this.setUiConfigHide('changeEventName', true);
            this.setUiConfigHide('clickEventName', false);
            this.setUiConfigHide('clickEventParam', false);

            if (this.handleMimeAnomalies() == 'JSON') {
                this.setUiConfigHide('selectItemEventName', false);
                this.setUiConfigHide('selectItemEventParam', false);
            } else {
                this.setUiConfigHide('selectItemEventName', true);
                this.setUiConfigHide('selectItemEventParam', true);
            }
        }
        super.componentStoreUpdates();
        super.initApplyStoreToDynamic(true);

    }


    openEventsExplorerDialog(e, value) {
        const data: IEventBlock = {
            eventName: value.name,
            eventBlockId: this.sceneItemId,
            blockName: this.sceneItem.$.label,
            eventSceneId: this.sceneId,
            eventType: '',
            sceneName: ''
        };
        const dialogRefVal = this.dialog.open(DialogEventsExplorerComponent, {
            height: '85%',
            width: '70%',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((result: IEventBlock) => {
                    if (!result) return;
                    this.submit(this.getEventsJsonData(result.eventName));
                })
        );
    }

    openJsonTextEditorDialog(fieldName: string, mode: EditorMode = 'json') {
        const currentValue = this.form?.value?.[fieldName] || '';
        // Detect if the current value is valid JSON to set initial mode
        let initialMode: EditorMode = mode;
        if (currentValue) {
            try {
                JSON.parse(currentValue);
                initialMode = 'json';
            } catch {
                initialMode = 'text';
            }
        }
        const data: DialogJsonEditorData = {
            json: currentValue,
            title: this.translocoService.translate('general.editParam', {}, this.translocoService.getActiveLang()),
            mode: initialMode,
            allowModeSwitch: true,
            showAddPosition: true
        };
        const dialogRefVal = this.dialog.open(DialogJsonEditorComponent, {
            height: '70%',
            width: '60%',
            data
        });
        this.cod(
            dialogRefVal.afterClosed()
                .pipe(take(1))
                .subscribe((result: string) => {
                    if (result === undefined || result === null) return;
                    debugger;
                    this.setFormValue(fieldName, result);
                    this.submit(this.form.value);
                })
        );
    }

    private getEventsJsonData(i_clickEventName = null, i_clickEventParam = null, i_selectItemEventName = null, i_selectItemEventParam = null, i_changeEventName = null): IPlayerPropsEvents {
        const m_clickEventName = !isNullOrUndef(i_clickEventName) ? i_clickEventName : this.sceneItem.$.clickEventName;
        const m_clickEventParam = !isNullOrUndef(i_clickEventParam) ? i_clickEventParam : this.sceneItem.$.clickEventParam;
        const m_selectItemEventName = !isNullOrUndef(i_selectItemEventName) ? i_selectItemEventName : this.sceneItem.$.selectItemEventName;
        const m_selectItemEventParam = !isNullOrUndef(i_selectItemEventParam) ? i_selectItemEventParam : this.sceneItem.$.selectItemEventParam;
        const m_changeEventName = !isNullOrUndef(i_changeEventName) ? i_changeEventName : this.sceneItem.$.changeEventName;
        return {
            clickEventName: m_clickEventName,
            clickEventParam: m_clickEventParam,
            selectItemEventName: m_selectItemEventName,
            selectItemEventParam: m_selectItemEventParam,
            changeEventName: m_changeEventName
        };
    }

    override submit(formValues) {
        // formValues = removeUndefNulls(formValues);
        // Handle clickEventParam validation and formatting
        if (formValues.clickEventParam) {
            const param = formValues.clickEventParam;

            // 1. If valid JSON, nothing to do
            if (!isStringBasedJson(param)) {
                // Not JSON, it's a plain string
                if (param.includes(' ')) {
                    // 3. String with spaces - must be in format "xxx" with allowed chars (a-z A-Z 0-9 _ - space)
                    if (param.startsWith('"') && param.endsWith('"')) {
                        // Already quoted - clean the inner content
                        const inner = param.slice(1, -1);
                        const cleanedInner = inner.replace(/[^a-zA-Z0-9_\- ]/g, '');
                        formValues.clickEventParam = `"${cleanedInner}"`;
                    } else {
                        // Not quoted - clean and wrap in quotes
                        const cleaned = param.replace(/[^a-zA-Z0-9_\- ]/g, '');
                        formValues.clickEventParam = `"${cleaned}"`;
                    }
                } else {
                    // 2. String without space - only allow a-z A-Z 0-9 _
                    formValues.clickEventParam = param.replace(/[^a-zA-Z0-9_]/g, '');
                }
            }
        }
        const formData = this.getEventsJsonData(
            formValues.clickEventName,
            formValues.clickEventParam,
            formValues.selectItemEventName,
            formValues.selectItemEventParam,
            formValues.changeEventName
        );
        return super.submit(formData);
    }

    private handleMimeAnomalies(): MimeAnomalyType {
        switch (this.sceneItem.$.player) {
            case this.blockLabelRecords.CART.id: {
                return 'JSON';
            }
            case this.blockLabelRecords.JSON_PLAYER.id: {
                return 'JSON';
            }
            default: {
                return null;
            }
        }
    }


    override destroy() {
        // Lib.DevShow('porthandler: destroy send events ' + Math.random());
        this.dispatchEventsAll();
        super.destroy();
    }
}

// private handleMimeAnomalies(): MimeAnomalyType {
//     switch (this.sceneItem.$.player) {
//         case this.blockLabelRecords.STOCKS.id: {
//             return 'STOCKS';
//         }
//         case this.blockLabelRecords.XML.id: {
//             return 'XML';
//         }
//         case this.blockLabelRecords.CATALOG.id: {
//             return 'CATALOG';
//         }
//         case this.blockLabelRecords.CUSTOMRSS.id: {
//             return 'CUSTOM_RSS';
//         }
//         default: {
//             const playerId = this.storeSelector.isBlockIdJsonAliased(this.sceneItem);
//             switch (playerId) {
//                 case this.blockLabelRecords.NETFEED_NEWS.id: {
//                     return 'NETFEED_NEWS';
//                 }
//                 case this.blockLabelRecords.NETFEED_HOROSCOPE.id: {
//                     return 'NETFEED_HOROSCOPE';
//                 }
//                 default: {
//                     return 'JSON';
//                 }
//             }
//         }
//     }
// }
// this.debouncerFunc = _.debounce(() => {
//     const color = String(Lib.HexToDecimal('000000'));
//     this.dispatchSceneItemChanges({
//         sceneId: this.sceneId,
//         sceneItemId: this.sceneItem.$.id,
//         values: [{
//             key: 'color',
//             value: color,
//             storePath: `Data[0].Foo[0].$`
//         }]
//     });
// }, 100);
// readonly faRightFromBracket = faRightFromBracket;
// debouncerFunc;
// m_clickEventParam = '';
